<div class="page-wrapper chiller-theme toggled">
  <div (click)="toggleNav()" class="btn btn-sm btn-dark show-sidebar hamburger">
    <i class="fa fa-bars"></i>
  </div>

  <nav id="sidebar" class="sidebar-wrapper">
    <div class="sidebar-content">

      <!-- Brand Section -->
      <div class="sidebar-brand d-flex align-items-center">
        <img class="appLogo img-fluid" src="../../../../assets/web-logo.png" alt="App Logo">
        <!-- <span class="brand-name">My App</span> -->
        <div class="close-sidebar hamburger ml-auto" (click)="closeNav()">
          <i class="fa fa-times"></i>
        </div>
      </div>

      <!-- Sidebar Menu -->
      <div class="sidebar-menu" style="color:#fff;">
        <ul>

          <!-- Dashboard -->
          <li (click)="dashboard()" #box (mouseover)="onMouseOver($event)" (mouseout)="onMouseOut($event)">
            <div class="menu-item">
              <img src="../../../../assets/side-menu/dashboard.png" class="email-icon" *ngIf="showWhite">
              <img src="../../../assets/side-menu/dashboard2.png" class="email-icon" *ngIf="showNormal">
              <span class="menu-text">Dashboard</span>
            </div>
          </li>
           <!-- View Student Top College Admissions -->
          <li (click)="Viewtopadmission()" #box (mouseover)="onMouseOver($event)" (mouseout)="onMouseOut($event)">
            <div class="menu-item">
              <img src="../../../../assets/side-menu/add video.png" class="email-icon" *ngIf="showWhiteClgVideo">
              <img src="../../../assets/side-menu/add video.png" class="email-icon" *ngIf="showNormalClgVideo">
              <span class="menu-text">View Student Top College Admissions</span>
            </div>
          </li>

          <!-- View Student Top College Admissions -->
      
          <!-- Colleges Dropdown -->
          <li class="sidebar-dropdown" #boxClg>
            <div class="collegeEve menu-item" (click)="college()" (mouseover)="mouseOverClg($event)" (mouseout)="mouseOutClg($event)">
              <img src="../../../../assets/side-menu/college.png" class="email-icon" *ngIf="showWhiteClg">
              <img src="../../../assets/side-menu/college2.png" class="email-icon" *ngIf="showNormalClg">
              <span class="menu-text">Colleges</span>
              <i class="fa fa-angle-down ml-auto" aria-hidden="true"></i>
            </div>
            <div [@toggleBox]="isCollegeOpen ? 'open' : 'closed'">
              <ul *ngIf="isCollegeOpen" class="submenu">

                <li class="courseSub" (click)=addcollege() #boxAdClg (mouseover)="mouseOverAdClg($event)" (mouseout)="mouseOutAdClg($event)">
                  <div class="menu-item">
                    <img src="../../../../assets/side-menu/college.png" class="email-icon" *ngIf="showWhiteAC">
                    <img src="../../../../assets/side-menu/college2.png" class="email-icon" *ngIf="showNormalAC">
                    <span class="menu-text">Add Colleges</span>
                  </div>
                </li>

                <li class="courseSub" (click)=addcoursecollege() #boxClgCourse (mouseover)="mouseOverClgCourse($event)" (mouseout)="mouseOutClgCourse($event)">
                  <div class="menu-item">
                    <img src="../../../assets/side-menu/degree-details.png" class="email-icon" *ngIf="showWhiteClgCourse">
                    <img src="../../../assets/side-menu/degree-details2.png" class="email-icon" *ngIf="showNormalClgCourse">
                    <span class="menu-text">Add Courses for Colleges</span>
                  </div>
                </li>

                <li class="courseSub" (click)="addVideos()" #boxClgVideo (mouseover)="mouseOverClgVideo($event)" (mouseout)="mouseOutClgVideo($event)">
                  <div class="menu-item">
                    <img src="../../../../assets/side-menu/add video.png" class="email-icon" *ngIf="showWhiteClgVideo">
                    <img src="../../../../assets/side-menu/add-video.png" class="email-icon" *ngIf="showNormalClgVideo">
                    <span class="menu-text">Add College Videos</span>
                  </div>
                </li>


                <li class="courseSub" (click)="addClgImages()" #boxClgImage (mouseover)="mouseOverClgImage($event)" (mouseout)="mouseOutClgImage($event)">
                  <div class="menu-item">
                    <img src="../../../../assets/side-menu/add college2.png" class="email-icon" *ngIf="showWhiteClgImage">
                    <img src="../../../../assets/side-menu/add-college.png" class="email-icon" *ngIf="showNormalClgImage">
                    <span class="menu-text">Add College Images</span>
                  </div>
                </li>
    <li class="courseSub"
    (click)="orderCollege()"
    #boxOrderClg
    (mouseover)="mouseOverOrderClg($event)"
    (mouseout)="mouseOutOrderClg($event)">
  <div class="menu-item">
    <!-- White logo version -->
    <img src="../../../../assets/order-college.png"
         class="email-icon large-logo"
         *ngIf="showWhiteOrderClg"
         alt="Order College White Logo" />

    <!-- Normal logo version -->
    <img src="../../../../assets/order-college.png"
         class="email-icon large-logo"
         *ngIf="showNormalOrderClg"
         alt="Order College Normal Logo" />

    <span class="menu-text">Order College</span>
  </div>
</li>

              </ul>
            </div>
          </li>
          <!-- Foreign Universities Dropdown -->
<li class="sidebar-dropdown" #boxForeignUni>
  <div class="collegeEve menu-item"
       (click)="toggleForeignUni()"
       (mouseover)="mouseOverForeignUni($event)"
       (mouseout)="mouseOutForeignUni($event)">
    <img src="../../../../assets/side-menu/college.png" class="email-icon" *ngIf="showWhiteForeignUni">
    <img src="../../../assets/side-menu/college2.png" class="email-icon" *ngIf="showNormalForeignUni">
    <span class="menu-text">Foreign University</span>
    <i class="fa fa-angle-down ml-auto" aria-hidden="true"></i>
  </div>

  <div [@toggleBox]="isForeignUniOpen ? 'open' : 'closed'">
    <ul *ngIf="isForeignUniOpen" class="submenu">

      <!-- Add Courses -->
      <li class="courseSub"
          (click)="addForeignCourses()"
          (mouseover)="mouseOverForeignCourses($event)"
          (mouseout)="mouseOutForeignCourses($event)">
        <div class="menu-item">
          <i class="fa fa-graduation-cap email-icon"></i>
           <!-- <i class="fa fa-graduation-cap fa-lg email-icon"></i>   -->
          <span class="menu-text">Add Courses</span>
        </div>
      </li>

      <!-- Add Colleges -->
      <li class="courseSub"
          (click)="addForeignColleges()"
          (mouseover)="mouseOverForeignColleges($event)"
          (mouseout)="mouseOutForeignColleges($event)">
        <div class="menu-item">
          <i class="fa fa-university email-icon"></i>
           <!-- <i class="fa fa-university fa-2x email-icon"></i>    -->
          <span class="menu-text">Add Colleges</span>
        </div>
      </li>

      <!-- Add Fees -->
      <li class="courseSub"
          (click)="addForeignCollegeFees()"
          (mouseover)="mouseOverForeignCollegeFees($event)"
          (mouseout)="mouseOutForeignCollegeFees($event)">
        <div class="menu-item">
          <i class="fa fa-file-invoice-dollar email-icon"></i>
           <!-- <i class="fa fa-file-invoice-dollar fa-lg email-icon"></i> -->
          <span class="menu-text">Add Fees</span>
        </div>
      </li>

      <!-- Add Images -->
      <li class="courseSub"
          (click)="addForeignCollegeImages()"
          (mouseover)="mouseOverForeignCollegeImages($event)"
          (mouseout)="mouseOutForeignCollegeImages($event)">
        <div class="menu-item">
          <i class="fa fa-image email-icon"></i>
           <!-- <i class="fa fa-image fa-lg email-icon"></i> -->
          <span class="menu-text">Add Images</span>
        </div>
      </li>

      <!-- Add Videos -->
      <li class="courseSub"
          (click)="addForeignCollegeVideos()"
          (mouseover)="mouseOverForeignCollegeVideos($event)"
          (mouseout)="mouseOutForeignCollegeVideos($event)">
        <div class="menu-item">
          <i class="fa fa-video email-icon"></i>
           <!-- <i class="fa fa-video fa-lg email-icon"></i> -->
          <span class="menu-text">Add Videos</span>
        </div>
      </li>
   <li class="courseSub"
    (click)="foreignorderCollege()"
    #boxOrderClg
    (mouseover)="mouseOverOrderClg($event)"
    (mouseout)="mouseOutOrderClg($event)">
  <div class="menu-item">
    <!-- White logo version -->
    <img src="../../../../assets/order-college.png"
         class="email-icon large-logo"
         *ngIf="showWhiteOrderClg"
         alt="Order College White Logo" />

    <!-- Normal logo version -->
    <img src="../../../../assets/order-college.png"
         class="email-icon large-logo"
         *ngIf="showNormalOrderClg"
         alt="Order College Normal Logo" />

    <span class="menu-text">Order College</span>
  </div>
</li>
    </ul>
  </div>
</li>



          <!-- Course Details Dropdown -->
          <li class="sidebar-dropdown" #boxCourses>
            <div class="collegeEve menu-item" (click)="courseDetails()" (mouseover)="mouseOverCourse($event)" (mouseout)="mouseOutCourse($event)">
              <img src="../../../assets/side-menu/college-details.png" class="email-icon" *ngIf="showWhiteCourse">
              <img src="../../../assets/side-menu/college-details2.png" class="email-icon" *ngIf="showNormalCourse">
              <span class="menu-text">Course Details</span>
              <i class="fa fa-angle-down ml-auto" aria-hidden="true"></i>
            </div>
            <div [@toggleBox]="isOpen ? 'open' : 'closed'">
              <ul *ngIf="isOpen" class="submenu">

                <li class="courseSub" (click)="courses()" (mouseover)="mouseOverAdCourse($event)" (mouseout)="mouseOutAdCourse($event)">
                  <div class="menu-item">
                    <img src="../../../../assets/side-menu/Course.png" class="email-icon" *ngIf="showWhiteAdCourse">
                    <img src="../../../../assets/side-menu/course2.png" class="email-icon" *ngIf="showNormalAdCourse">
                    <span class="menu-text">Course</span>
                  </div>
                </li>

                <li class="courseSub" (click)=degreeType() (mouseover)="mouseOverDegreeType($event)" (mouseout)="mouseOutDegreeType($event)">
                  <div class="menu-item">
                    <img src="../../../assets/side-menu/degree-details.png" class="email-icon" *ngIf="showWhiteDegreetype">
                    <img src="../../../assets/side-menu/degree-details2.png" class="email-icon" *ngIf="showNormalDegreetype">
                    <span class="menu-text">Degree Type</span>
                  </div>
                </li>

                <li class="courseSub" (click)="courseType()" (mouseover)="mouseOverCourseType($event)" (mouseout)="mouseOutCourseType($event)">
                  <div class="menu-item">
                    <img src="../../../assets/side-menu/Course type.png" class="email-icon" *ngIf="showWhiteCoursetype">
                    <img src="../../../assets/side-menu/course-type2.png" class="email-icon" *ngIf="showNormalCoursetype">
                    <span class="menu-text">Course Type</span>
                  </div>
                </li>

                <li class="courseSub" (click)="degree()" (mouseover)="mouseOverDegree($event)" (mouseout)="mouseOutDegree($event)">
                  <div class="menu-item">
                    <img src="../../../assets/side-menu/Degree.png" class="email-icon" *ngIf="showWhiteDegree">
                    <img src="../../../assets/side-menu/degree2.png" class="email-icon" *ngIf="showNormalDegree">
                    <span class="menu-text">Degree</span>
                  </div>
                </li>

                <li class="courseSub" (click)="addcourseDetails()" (mouseover)="mouseOverCourseDetails($event)" (mouseout)="mouseOutCourseDetails($event)">
                  <div class="menu-item">
                    <img src="../../../../assets/side-menu/course-details.png" class="email-icon" *ngIf="showWhiteCourseDetails">
                    <img src="../../../../assets/side-menu/course-details2.png" class="email-icon" *ngIf="showNormalCourseDetails">
                    <span class="menu-text">Course Details</span>
                  </div>
                </li>

              </ul>
            </div>
          </li>

          <!-- Study Materials Dropdown -->
          <li class="sidebar-dropdown" #boxClg>
            <div class="collegeEve menu-item" (click)="materials()" (mouseover)="mouseOverClg($event)" (mouseout)="mouseOutClg($event)">
              <img src="../../../../assets/side-menu/material.png" class="email-icon" *ngIf="showWhiteClg">
              <img src="../../../assets/side-menu/material.png" class="email-icon" *ngIf="showNormalClg">
              <span class="menu-text">Study Materials</span>
              <i class="fa fa-angle-down ml-auto" aria-hidden="true"></i>
            </div>
            <div [@toggleBox]="isMaterialOpen ? 'open' : 'closed'">
              <ul *ngIf="isMaterialOpen" class="submenu">

                <li class="courseSub" (click)=addmaterialcategory()>
                  <div class="menu-item">
                    <img src="../../../../assets/side-menu/college.png" class="email-icon" *ngIf="showWhiteAC">
                    <img src="../../../../assets/side-menu/college2.png" class="email-icon" *ngIf="showNormalAC">
                    <span class="menu-text">Add Materials Category</span>
                  </div>
                </li>

                <li class="courseSub" (click)=addmaterialsubjects()>
                  <div class="menu-item">
                    <img src="../../../assets/side-menu/degree-details.png" class="email-icon" *ngIf="showWhiteClgCourse">
                    <img src="../../../assets/side-menu/degree-details2.png" class="email-icon" *ngIf="showNormalClgCourse">
                    <span class="menu-text">Add Subjects to Materials</span>
                  </div>
                </li>

                <li class="courseSub" (click)="addmaterialdocuments()">
                  <div class="menu-item">
                    <img src="../../../../assets/side-menu/add video.png" class="email-icon" *ngIf="showWhiteClgVideo">
                    <img src="../../../../assets/side-menu/add-video.png" class="email-icon" *ngIf="showNormalClgVideo">
                    <span class="menu-text">Add Material Documents</span>
                  </div>
                </li>

                <li class="courseSub" (click)="Viewmaterialyllsbus()">
                  <div class="menu-item">
                    <img src="../../../../assets/side-menu/add video.png" class="email-icon" *ngIf="showWhiteClgVideo">
                    <img src="../../../../assets/side-menu/add-video.png" class="email-icon" *ngIf="showNormalClgVideo">
                    <span class="menu-text">Add Material Syllabus</span>
                  </div>
                </li>

              </ul>
            </div>
          </li>

          <!-- Scope -->
          <li (click)="scope()" #boxScope>
            <div class="menu-item">
              <img src="../../../../assets/side-menu/scope.png" class="email-icon" *ngIf="showWhiteScope">
              <img src="../../../../assets/side-menu/scope2.png" class="email-icon" *ngIf="showNormalScope">
              <span class="menu-text">Scope</span>
            </div>
          </li>

          <!-- Add Country -->
          <li (click)="addCountry()" #boxCountry>
            <div class="menu-item">
              <img src="../../../../assets/side-menu/country.png" class="email-icon" *ngIf="showWhiteCountry">
              <img src="../../../../assets/side-menu/country2.png" class="email-icon" *ngIf="showNormalCountry">
              <span class="menu-text">Add Country</span>
            </div>
          </li>

          <!-- Add District -->
          <li (click)="addDistrict()" #boxCountry>
            <div class="menu-item">
              <img src="../../../../assets/side-menu/district2.png" class="email-icon">
              <span class="menu-text">Add District</span>
            </div>
          </li>

          <!-- Add State -->
          <li (click)="addState()" #boxCountry>
            <div class="menu-item">
              <img src="../../../../assets/side-menu/state2.png" class="email-icon">
              <span class="menu-text">Add State</span>
            </div>
          </li>

          <!-- Add Trending News -->
          <li (click)="addTrendingNews()" #boxCountry>
            <div class="menu-item">
              <img src="../../../../assets/side-menu/trending_news.png" class="email-icon">
              <span class="menu-text">Add Trending News</span>
            </div>
          </li>

          <!-- Add Top 10 Colleges -->
          <li (click)="addTopColleges()" #boxCountry>
            <div class="menu-item">
              <img src="../../../../assets/side-menu/district2.png" class="email-icon">
              <span class="menu-text">Add Top 10 Colleges</span>
            </div>
          </li>

          <!-- Advertisement Images -->
          <li (click)="adImages()" #boximage>
            <div class="menu-item">
              <img src="../../../../assets/side-menu/ad-image.png" class="email-icon" *ngIf="showWhiteAdimage">
              <img src="../../../../assets/side-menu/ad-image2.png" class="email-icon" *ngIf="showNormalAdimage">
              <span class="menu-text">Advertisement Images</span>
            </div>
          </li>

          <!-- Video URL -->
          <li (click)="videourl()" #boximage>
            <div class="menu-item">
              <img src="../../../../assets/side-menu/ad-image.png" class="email-icon" *ngIf="showWhiteAdimage">
              <img src="../../../../assets/side-menu/ad-image2.png" class="email-icon" *ngIf="showNormalAdimage">
              <span class="menu-text">Video URL</span>
            </div>
          </li>

          <!-- Material Subscription Details -->
          <li (click)="ViewMaterialSub()" #boximage>
            <div class="menu-item">
              <img src="../../../../assets/side-menu/ad-image.png" class="email-icon" *ngIf="showWhiteAdimage">
              <img src="../../../../assets/side-menu/ad-image2.png" class="email-icon" *ngIf="showNormalAdimage">
              <span class="menu-text">Material Subscription Details</span>
            </div>
          </li>

          <!-- User Roles -->
          <li (click)="userRole()" #boxuser>
            <div class="menu-item">
              <img src="../../../../assets/side-menu/user-roles.png" class="email-icon" *ngIf="showWhiteuser">
              <img src="../../../../assets/side-menu/users-roles2.png" class="email-icon" *ngIf="showNormaluser">
              <span class="menu-text">User Roles</span>
            </div>
          </li>

          <!-- Account -->
          <li (click)="adminUpdate()" #boxadmin>
            <div class="menu-item">
              <img src="../../../assets/side-menu/Profile.png" class="email-icon" *ngIf="showWhiteadmin">
              <img src="../../../assets/side-menu/profile2.png" class="email-icon" *ngIf="showNormaladmin">
              <span class="menu-text">Account</span>
            </div>
          </li>

          <!-- Payments -->
          <li (click)="payments()" #boxadmin>
            <div class="menu-item">
              <img src="../../../assets/side-menu/settings.png" class="email-icon">
              <span class="menu-text">Payments</span>
            </div>
          </li>

          <!-- Course Payments -->
          <li (click)="coursePayments()" #boxadmin>
            <div class="menu-item">
              <img src="../../../assets/side-menu/settings.png" class="email-icon">
              <span class="menu-text">Course Payments</span>
            </div>
          </li>

          <!-- Material Payment -->
          <li (click)="ViewMaterialPayment()" #boxadmin>
            <div class="menu-item">
              <img src="../../../assets/side-menu/settings.png" class="email-icon">
              <span class="menu-text">Material Payment</span>
            </div>
          </li>

          <!-- Logout -->
          <li (click)="signout()" #boxlogout>
            <div class="menu-item">
              <img src="../../../assets/side-menu/logout.png" class="email-icon" *ngIf="showWhitelogout">
              <img src="../../../assets/side-menu/logout2.png" class="email-icon" *ngIf="showNormallogout">
              <span class="menu-text">Logout</span>
            </div>
          </li>

        </ul>
      </div>
    </div>
  </nav>

  <!-- Backdrop -->
  <div class="backdrop" [ngStyle]="{'display':display}"></div>

  <!-- Success Modal -->
  <div class="modal" id="successModel" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header"></div>
        <div class="dltmodal-content animate modal-body dltBl mb-3" style="text-align:center;">
          <p>Confirmation</p>
          <button type="submit" class="btn btn-success" (click)="ok()" style="width: 20%;">Yes</button>
          <button type="submit" class="btn btn-danger" (click)="onCloseHandled()" style="width: 20%;margin-left: 0.3em;">Cancel</button><br><br>
          <p class="error" *ngIf="showError">{{ErrorMsg}}</p>
        </div>
      </div> <!-- modal-content -->
    </div> <!-- modal-dialog -->
  </div> <!-- modal -->
</div> <!-- page-wrapper -->
